import Api from '@/services/Api'

export default {
  add (info) {
    return Api().post('library/add', info)
  },
  remove (info) {
    return Api().post('library/remove', info)
  },
  visit (info) {
    return Api().post('library/visit', info)
  },
  favorite (info) {
    return Api().post('library/favorite', info)
  },
  get (info) {
    return Api().post('library/get', info)
  },
  getRaw (info) {
    return Api().post('library/get/raw', info)
  }
}
